<template>
	<div class="form">
		<div class="form-title">
			<p>Login</p>
		</div>
		<div class="form-field">
			<label class="form-field__label" for="login"> User: </label>
			<input
				:class="loginRequired || wrongFormat ? 'alert' : ''"
				class="form-field__input"
				placeholder="email@email.com.br"
				type="text"
				name="login"
				id="login-input"
				v-model="login"
				autocomplete="off"
				@input="loginRequired = false"
			/>
			<small class="form-field__input--required" v-if="wrongFormat"> E-mail inválido. </small>
			<small class="form-field__input--required" v-show="loginRequired"> Campo obrigatório. </small>
		</div>
		<div class="form-field">
			<label class="form-field__label" for="login"> Senha: </label>
			<InputPassword
				id="password-input"
				v-model="password"
				:alertClass="passwordRequired"
				@emitEnter="doLogin"
				@clearRequired="passwordRequired = false"
			/>
			<div class="row">
				<small class="form-field__input--required" v-if="passwordRequired">
					Campo obrigatório.
				</small>
				<span class="form-field__forgot" @click="goToForgotPassword()"> Esqueci minha senha </span>
			</div>
		</div>
		<div class="form-action">
			<button class="form-action__btn" :class="isLoginLoading ? 'disabled' : ''" @click="doLogin()">
				<span v-if="!isLoginLoading">Entrar</span>
				<SpinnerIcon :color="'white'" v-else />
			</button>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { LOGIN_REQUEST, USER_INFO_REQUEST } from '@/store/modules/login/login/actions';
import CryptoJS from 'crypto-js';
import InputPassword from '@/components/shared/InputPassword/InputPassword.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';

export default {
	name: 'LoginForm',
	components: { InputPassword, SpinnerIcon },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		login: null,
		password: null,
		loginRequired: false,
		passwordRequired: false,
		wrongFormat: false,
	}),
	mounted() {},
	methods: {
		...mapActions('login', {
			loginRequest: LOGIN_REQUEST,
			getUserInfo: USER_INFO_REQUEST,
		}),
		validateEmail(email) {
			let emailRegex = /\S+@\S+\.\S+/;
			return emailRegex.test(email);
		},
		doLogin() {
			this.loginRequired = false;
			this.passwordRequired = false;
			this.wrongFormat = false;

			if (!this.login) {
				this.loginRequired = true;
				return;
			}

			if (!this.validateEmail(this.login)) {
				this.wrongFormat = true;
				return;
			}

			if (!this.password) {
				this.passwordRequired = true;
				return;
			}

			const fixedKey = process.env.VUE_APP_FIXED_KEY;
			const getEmailChars = this.login.substring(0, 4);

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(new RegExp(':', 'g'), '');

			const key = `${fixedKey}${getEmailChars}${formatHour}`;
			const encryptedPassword = CryptoJS.AES.encrypt(this.password, key);

			const body = {
				email: this.login.trim(),
				password: encryptedPassword.toString(),
			};

			this.loginRequest({ login: body, vm: this, timestamp: timestamp }).then((res) => {
				if (res.status == 201) {
					if (res.data.token != undefined && res.data.token != null) {
						this.getUserInfo().then((res) => {
							if (res.status == 200) {
								this.$router.push({ path: '/dashboard/analytics' });
							}
						});
					} else {
						return this.$toastr.e('Para acessar a plataforma é necessário ser administrador.');
					}
				}
			});
		},
		goToForgotPassword() {
			this.$emit('handleForgotForm');
		},
	},
	computed: {
		...mapGetters('login', ['isLoginLoading']),
	},
};
</script>

<style lang="scss" scoped>
@import 'LoginForm.scss';
</style>
